import { ErrorBoundary } from '@enter/core';
import { AcceptInvitation, Expired, Logout, Main, NotFound, Redirect, Version } from 'pages';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { PrivateRoute } from './private-route';

export function AppRouter(): React.ReactElement {
    return (
        <Router>
            <Routes>
                <Route path="/accept_invitation" element={<AcceptInvitation />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/expired" element={<Expired />} />
                <Route path="/redirect" element={<Redirect />} />
                <Route path="/version" element={<Version />} />
                <Route path="/404" element={<NotFound />} />
                <Route 
                    path="/*" 
                    element={
                        <ErrorBoundary>
                            <PrivateRoute>
                                <Main />
                            </PrivateRoute>
                        </ErrorBoundary>
                    } 
                />
            </Routes>
        </Router>
    );
}
